import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';
import { CustomPointOfService } from '@shop/const';
import { ShopWorkingTimeService } from '@shop/feature';

@Component({
  selector: 'sd-shop-working-time',
  imports: [SdvorIconComponent],
  templateUrl: './shop-working-time.component.html',
  styleUrls: ['./shop-working-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopWorkingTimeComponent implements OnChanges {
  iconTypes = IconTypes;

  @Input() shop: CustomPointOfService;

  @HostBinding('class.noctidial') noctidial = false;
  @HostBinding('class.closed') closed = false;

  workingTime: string;

  constructor(private shopWorkingTimeService: ShopWorkingTimeService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.shop?.currentValue) {
      const { noctidial, closed, text } = this.shopWorkingTimeService.getWorkingTimeInfo(this.shop);
      this.noctidial = noctidial;
      this.closed = closed;
      this.workingTime = text;
    }
  }
}
